
import Vue from 'vue'
import Button from './Button.vue'
import ActivityDescription from './ActivityDescription.vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import {
  URLParameterRange_ActivityType,
  ProjectPath,
  ProjectState,
} from '../channel.types'

export default Vue.extend({
  props: {
    path: Object,
  },

  methods: {
    triggerClick() {
      const activityId = this.path.activity.id
      const rowId = this.path.row.id
      const channelSlug = this.$route.params.channelSlug
      const articleType = this.path.row.is_enabled_article_format
        ? URLParameterRange_ActivityType.ARTICLE
        : URLParameterRange_ActivityType.ACTIVITY
      const path = `/c/${channelSlug}/${rowId}/${articleType}/${activityId}/play`

      this.$router.push({ path })
    },

    handleFavoriteClick() {
      this.$store.dispatch('handle_favorite_click', this.path)
    },
    trackShareClick() {
      this.$store.dispatch('track_share_click', this.path)
    },
  },
  components: {
    Button,
    ActivityDescription,
  },
  computed: {
    ...mapGetters({
      _fullActivityUrl: 'fullActivityUrl',
      _isFavorite: 'isFavorite',
    }),

    fullActivityUrl() {
      return this._fullActivityUrl(this.path)
    },
    isFavorite() {
      return this._isFavorite(this.path)
    },
  },
})
